import { episodes } from "@/mocks/episodes";
import { actors } from "@/mocks/actors";
import { plots } from "@/mocks/plots";

export interface SearchResult {
  type: "episode" | "actor" | "plot";
  id: string;
  title: string;
  subtitle: string;
  link: string;
  cover: string;
}

const normalize = (value: string) => value.trim().toLowerCase();

/**
 * Front-end fuzzy search across episodes, actors and plot articles.
 * Matches by title, episode number, role name, actor name, tags and excerpt.
 */
export function searchAll(keyword: string): SearchResult[] {
  const q = normalize(keyword);
  if (!q) return [];

  const results: SearchResult[] = [];

  episodes.forEach((item) => {
    const haystack = [item.title, item.summary, `第${item.ep}集`, `ep${item.ep}`, ...item.highlights]
      .join(" ")
      .toLowerCase();
    if (haystack.includes(q)) {
      results.push({
        type: "episode",
        id: item.id,
        title: `第${item.ep}集 · ${item.title}`,
        subtitle: item.summary.slice(0, 42) + "…",
        link: `/detail/episode/${item.id}`,
        cover: item.cover,
      });
    }
  });

  actors.forEach((item) => {
    const haystack = [item.name, item.role, item.roleType, item.shortBio, item.bio].join(" ").toLowerCase();
    if (haystack.includes(q)) {
      results.push({
        type: "actor",
        id: item.id,
        title: `${item.name} · 饰 ${item.role}`,
        subtitle: item.shortBio.slice(0, 42) + "…",
        link: `/detail/actor/${item.id}`,
        cover: item.avatar,
      });
    }
  });

  plots.forEach((item) => {
    const haystack = [item.title, item.excerpt, ...item.tags].join(" ").toLowerCase();
    if (haystack.includes(q)) {
      results.push({
        type: "plot",
        id: item.id,
        title: item.title,
        subtitle: item.excerpt.slice(0, 42) + "…",
        link: `/detail/plot/${item.id}`,
        cover: item.thumbnail,
      });
    }
  });

  return results;
}

export const searchTypeLabel: Record<SearchResult["type"], string> = {
  episode: "剧集",
  actor: "演员",
  plot: "剧情解析",
};